"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = require("./base");

var ConditionalSubBlock =
/*#__PURE__*/
function (_BlockContainer) {
  babelHelpers.inherits(ConditionalSubBlock, _BlockContainer);

  function ConditionalSubBlock() {
    babelHelpers.classCallCheck(this, ConditionalSubBlock);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(ConditionalSubBlock).apply(this, arguments));
  }

  return ConditionalSubBlock;
}(_base.BlockContainer);

exports.default = ConditionalSubBlock;